export default __webpack_public_path__ + "static/media/community-header-bg.324f60b8.png";